export const SITE_URL = "https://american-farmstand.com";

export const PUBLIC_PAGE_META = {
  "/": {
    title: "American Farmstand | Buy Direct from Independent Farms",
    description: "American Farmstand: shop food directly from American farms, and discover farms, farmstands and farmers markets near you across the United States.",
  },
  "/for-farms": {
    title: "Sell Directly to Customers | American Farmstand for Farms",
    description: "Independent American farms list their products, set their own prices and fulfillment, and sell directly to members. Farm pricing: 0% for the first year, then 2% — only when you make a sale, excluding tax and shipping.",
  },
  "/for-customers": {
    title: "Buy Farm Food Online | American Farmstand",
    description: "Order food online directly from independent American farms. Members browse farm profiles and buy from each farm; what's offered, shipping and pickup vary by farm.",
  },
  "/our-marketplace": {
    title: "How to Buy Directly from Farms | American Farmstand",
    description: "Members order directly from independent American farms online, from one farm or several. Each farm sets its own shipping, delivery or pickup.",
  },
  "/about": {
    title: "About American Farmstand | Independent Farm Marketplace",
    description: "American Farmstand is an independent online marketplace for buying food directly from American farms, with a directory of farms, farmstands and farmers markets.",
  },
  "/faq": {
    title: "FAQ | American Farmstand",
    description: "Answers about American Farmstand accounts, the $12/month marketplace membership, how farms fulfill orders, directory listings and Farmstand fees for farms.",
  },
  "/getting-started": {
    title: "Getting Started for Farms | American Farmstand",
    description: "A short step-by-step guide for farms setting up on American Farmstand: profile, products, fulfillment, payouts and your first orders.",
  },
  "/privacy": {
    title: "Privacy Policy | American Farmstand",
    description: "How American Farmstand collects, uses and protects information from members, farms and visitors.",
  },
  "/terms": {
    title: "Terms of Service | American Farmstand",
    description: "The terms that govern use of American Farmstand by members, farms and visitors.",
  },
  "/contact": {
    title: "Contact Us | American Farmstand",
    description: "Questions for American Farmstand from farms or customers? Send us a message and our team will get back to you.",
  },
};

const KIND = { farm: "Farm", farmstand: "Farmstand" };
// Title/description for a directory or farmers market detail page (shared with the build-time directory prerender).
export function detailMeta(m, isDirectory) {
  if (!m) return PUBLIC_PAGE_META["/"];
  const place = [m.city, m.state].filter(Boolean).join(", ");
  const kind = isDirectory ? KIND[m.category] || "Farm" : "Farmers Market";
  return {
    title: `${m.name}${place ? ` — ${kind} in ${place}` : ""} | American Farmstand`,
    description: `${m.name} is a ${kind.toLowerCase()}${place ? ` in ${place}` : ""} listed in the American Farmstand directory of farms, farmstands and farmers markets. Details are from public sources; confirm hours and access before visiting.`,
  };
}
